import React from 'react';

import Image from '@atlaskit/image';

import SmartCreateDatabaseIcon from '../../../assets/database-smart-create-icon.svg';
import SmartCreateLiveDocIcon from '../../../assets/live-doc-smart-create-icon.svg';
import SmartCreateWhiteboardIcon from '../../../assets/whiteboard-smart-create-icon.svg';

type ContentType = 'whiteboard' | 'page' | 'livedoc' | 'database';

type SmartCreateIconProps = {
	contentType: ContentType;
};

const renderContentTypeIcon = (contentType: ContentType) => {
	switch (contentType) {
		case 'whiteboard':
			return SmartCreateWhiteboardIcon;
		case 'livedoc':
			return SmartCreateLiveDocIcon;
		case 'database':
			return SmartCreateDatabaseIcon;
		default:
			return SmartCreateLiveDocIcon;
	}
};

export const SmartCreateIcon = ({ contentType }: SmartCreateIconProps) => {
	return (
		<Image
			src={renderContentTypeIcon(contentType)}
			alt=""
			testId={`smart-create-icon-${contentType}`}
		/>
	);
};
